__turbopack_context__.v({
  "className": "figtree_88dc09a2-module__XsjGSq__className",
  "variable": "figtree_88dc09a2-module__XsjGSq__variable",
});
